export const MINIO_URL = process.env.REACT_APP_MINIO_URL || "https://s3.ir-thr-at1.arvanstorage.ir/apk-download/";

export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || "https://api.medrickian.com/api";

export const fetchGameData = async (params = {}) => {
    try {
        const {game_id} = params;
        let url = `${API_BASE_URL}/games/`
        if (game_id !== undefined) url += game_id;
        const response = await fetch(url);

        if (!response.ok) {
            throw new Error(`Failed to fetch games: ${response.status}`);
        }

        return await response.json();

    } catch (error) {
        console.error('Error fetching game data:', error);
        throw error;
    }
};